import Text from 'components/Text/Text';
import React, { useContext } from 'react';
import Button from 'components/Button/Button';
import breadcrumbs from 'images/breadcrumbs.svg';
import {
	ChangeGamePositionContext,
	IChangeGamePositionContext,
} from '../../../../../changeGamePositionState/changeGamePositionContext';
import classNames from 'classnames';
import style from './ResetBtn.module.scss';

const ResetBtn: React.FC = () => {
	const { resetSelectedControls, IDSelectedCustomer, IDSelectedRestaurant } =
		useContext<IChangeGamePositionContext>(ChangeGamePositionContext);

	const resetBtnClasses = classNames(style.resetBtn, {
		[style.active]: IDSelectedCustomer || IDSelectedRestaurant,
	});

	return (
		<Button
			className={resetBtnClasses}
			theme="secondary"
			onClick={resetSelectedControls}
			icon={
				<svg className={style.icon}>
					<use xlinkHref={`${breadcrumbs}#resetIcon`} />
				</svg>
			}
			data-test="ResetBtn">
			<Text translationNameSpace="listing" translationKey="resetButton" asFragment={true} />
		</Button>
	);
};

export default ResetBtn;
